import {server} from '../error/error';

import * as secretsPlatform from './secrets.switch';

export const get = function (key) {
    if (!secretsPlatform.secrets) {
        return null;
    }

    if (!(key in secretsPlatform.secrets)) {
        return null;
    }

    return secretsPlatform.secrets[key];
};

const _set = function (key, value, callback) {

    if (!key) {
        return setImmediate(
            callback.bind(null, new server.InternalServerError("Missing Key"))
        );
    }

    var doRet = function () {
        return setImmediate(callback);
    };

    var doSaveAndRet = function () {
        return secretsPlatform.save(callback);
    };

    if (value === undefined || value === null) {
        //Delete workflow
        if (!secretsPlatform.secrets || !(key in secretsPlatform.secrets)) {
            //Nothing to delete
            return doRet();
        }

        delete secretsPlatform.secrets[key];
        return doSaveAndRet();
    } else {
        //Add/Update workflow
        // if (!secretsPlatform.secrets) {
        //   secretsPlatform.secrets = {};
        // }
        secretsPlatform.secrets[key] = value;
        return doSaveAndRet();
    }
};

export const set = (key, value) => {
    return new Promise((resolve, reject) => {
        const callback = (err) => {
            if (err) {
                reject(err);
                return;
            }

            resolve();
        };
        _set(key, value, callback);
    });
};